import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { blockUser, restoreUser } from 'app/store/root/users/users.actions';
import { users } from 'app/store/root/users/users.selectors';
import { UserOutput } from 'core/http/root';
import { arrayFilter } from 'core/utils/rx-common';
import { Subject } from 'rxjs';
import { Uuid } from 'shared/common/types';
import { Criteria } from 'shared/criteria/Criteria';
import { EagerSource } from 'shared/modules/table/table-utils/table-interfaces';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UserComponent {
  readonly reloader = new Subject();

  constructor(private store$: Store) {}

  get columns(): string[] {
    return [
      'login',
      'user',
      'phone',
      'projects',
      'registeredAt',
      'isActivated',
    ];
  }

  dataSource: EagerSource<UserOutput> = (c: Criteria) => this.store$.select(users)
    .pipe(
      arrayFilter((user) => {
        return user.login.toLowerCase().includes(c.filter!.toLowerCase())
          || user.fullName.toLowerCase().includes(c.filter!.toLowerCase());
      }),
    );

  restoreAccount(id: Uuid): void {
    this.store$.dispatch(restoreUser({ id }));

    this.reloader.next(undefined);
  }

  blockAccount(id: Uuid): void {
    this.store$.dispatch(blockUser({ id }));

    this.reloader.next(undefined);
  }
}
